import * as React from "react";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000, // 5분,
            gcTime: 10 * 60 * 1000 // 10분
        },
        mutations: {
            retry: 1
        },
    },
});

interface AppProvidersProps {
    children: React.ReactNode;
}

export function AppProviders({children}: AppProvidersProps) {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
        </QueryClientProvider>
    )
}